<template>
	<div class="alcohol-disclaimer">
		<i alt="Martini Glass" class="sk-icon-glass-martini"></i>
		<span>
			This order contains alcohol. By ordering this item, you are
			attesting to the fact that you are least 21 years of age and that
			you will able to provide to the driver a government-issued id
			reflecting your age.
		</span>
	</div>
</template>

<style scoped>
.alcohol-disclaimer {
	display: flex;
	font-size: 12px;
}

.alcohol-disclaimer i {
	font-size: 15px;
	color: var(--gR-base-90);
	margin-top: 5px;
}

.alcohol-disclaimer span {
	margin-left: 13px;
	color: var(--sk-grey2);
}
</style>

<script>
export default {
	name: "AlcoholDisclaimer"
}
</script>